var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "health-report",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.427,
    height: 65.016,
    viewBox: "0 0 51.427 65.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54068",
    "data-name": "Path 54068",
    d: "M142,34.537V67.67H124.752a2.3,2.3,0,0,1-1.963-1.109l-3.047-5a2.3,2.3,0,0,0-1.963-1.109H104.1V39.062l5.762-5.762h30.915A1.235,1.235,0,0,1,142,34.537Z",
    transform: "translate(-97.751 -29.184)",
    fill: "#eaeffe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54069",
    "data-name": "Path 54069",
    d: "M134.946,116.917h-2.384a1.265,1.265,0,0,1-1.262-1.262V103.862a1.257,1.257,0,0,1,1.262-1.262h2.384a1.257,1.257,0,0,0-1.262,1.262v11.792A1.241,1.241,0,0,0,134.946,116.917Z",
    transform: "translate(-121.484 -89.649)",
    fill: "#f3ae83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54070",
    "data-name": "Path 54070",
    d: "M161.845,103.861v11.792a1.273,1.273,0,0,1-1.262,1.262h-9.421a1.265,1.265,0,0,1-1.262-1.262V103.861a1.257,1.257,0,0,1,1.262-1.262h9.421A1.249,1.249,0,0,1,161.845,103.861Z",
    transform: "translate(-137.712 -89.648)",
    fill: "#f6c9af"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54071",
    "data-name": "Path 54071",
    d: "M104.1,39.062l5.75-5.762v4.526a1.238,1.238,0,0,1-1.237,1.237Z",
    transform: "translate(-97.751 -29.184)",
    fill: "#d5dcf8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54072",
    "data-name": "Path 54072",
    d: "M64.333,280.045H56.595A2.293,2.293,0,0,1,54.3,277.75V248.595a2.285,2.285,0,0,1,2.295-2.295h7.738a2.285,2.285,0,0,0-2.295,2.295V277.75A2.293,2.293,0,0,0,64.333,280.045Z",
    transform: "translate(-54.3 -215.03)",
    fill: "#66aff1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54073",
    "data-name": "Path 54073",
    d: "M158.689,255.81v21.94a2.293,2.293,0,0,1-2.295,2.295h-39.1A2.293,2.293,0,0,1,115,277.75V248.595a2.285,2.285,0,0,1,2.295-2.295H127.3a2.272,2.272,0,0,1,1.963,1.109l3.047,5a2.328,2.328,0,0,0,1.963,1.109h22.131a2.274,2.274,0,0,1,2.282,2.295Z",
    transform: "translate(-107.262 -215.03)",
    fill: "#86c1f4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54074",
    "data-name": "Path 54074",
    d: "M57.447,215.138h-.752a2.285,2.285,0,0,0-2.295,2.295v-4.538a2.3,2.3,0,0,1,2.205-2.295Z",
    transform: "translate(-54.387 -183.881)",
    fill: "#4c9ced"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54075",
    "data-name": "Path 54075",
    d: "M408.577,212.995v11.754a2.285,2.285,0,0,0-2.295-2.295H401.4v-3.927l2.511-7.828h2.371A2.293,2.293,0,0,1,408.577,212.995Z",
    transform: "translate(-357.15 -183.968)",
    fill: "#4c9ced"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54076",
    "data-name": "Path 54076",
    d: "M306.109,64.315H307.7V62.722a1.122,1.122,0,1,1,2.244,0v1.594h1.594a1.122,1.122,0,0,1,0,2.244h-1.594v1.594a1.122,1.122,0,1,1-2.244,0V66.559h-1.594a1.122,1.122,0,0,1,0-2.244Z",
    transform: "translate(-273.04 -53.876)",
    fill: "#f44a7e"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54077",
    "data-name": "Path 54077",
    d: "M206.228,364.073h2.562V361.51a1.81,1.81,0,0,1,3.621,0v2.562h2.562a1.81,1.81,0,1,1,0,3.621h-2.562v2.562a1.81,1.81,0,1,1-3.621,0v-2.562h-2.562A1.811,1.811,0,0,1,206.228,364.073Z",
    transform: "translate(-185.308 -313.973)",
    fill: "#eaeffe"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54078",
    "data-name": "Path 54078",
    d: "M168.4,157.228V159.8h-6.5v-2.575a3,3,0,0,1,1.747-2.728,2.4,2.4,0,0,0,3.021,0A3.005,3.005,0,0,1,168.4,157.228Z",
    transform: "translate(-148.183 -134.933)",
    fill: "#44569b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54079",
    "data-name": "Path 54079",
    d: "M173.555,123.9a2.378,2.378,0,0,1-4.755,0A2.378,2.378,0,0,1,173.555,123.9Z",
    transform: "translate(-154.203 -106.183)",
    fill: "#6a88c8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46512",
    "data-name": "Group 46512",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54080",
    "data-name": "Path 54080",
    d: "M180.934,5.129H165.7l1.033-3.251a1.23,1.23,0,0,1,1.555-.8Z",
    transform: "translate(-151.501 -1.012)",
    fill: "#c0c8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54081",
    "data-name": "Path 54081",
    d: "M408.488,74.07c-1.619,5.048-5.52,17.21-7.088,22.119V70.5l6.3,2.014A1.239,1.239,0,0,1,408.488,74.07Z",
    transform: "translate(-357.153 -61.641)",
    fill: "#c0c8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54082",
    "data-name": "Path 54082",
    d: "M60.667,100v18.651H57.378c-.561-2.97-2.448-13.131-3.034-16.267a1.161,1.161,0,0,1,.931-1.377Z",
    transform: "translate(-54.321 -87.381)",
    fill: "#c0c8f3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46513",
    "data-name": "Group 46513",
    transform: "translate(26.62 14.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54083",
    "data-name": "Path 54083",
    d: "M267.152,117.377h-3.366a.689.689,0,0,1,0-1.377h3.366A.688.688,0,0,1,267.152,117.377Z",
    transform: "translate(-263.112 -116)",
    fill: "#44569b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46514",
    "data-name": "Group 46514",
    transform: "translate(26.62 18.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54084",
    "data-name": "Path 54084",
    d: "M276.089,150.277h-12.3a.689.689,0,0,1,0-1.377h12.3A.689.689,0,0,1,276.089,150.277Z",
    transform: "translate(-263.112 -148.9)",
    fill: "#44569b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46515",
    "data-name": "Group 46515",
    transform: "translate(26.62 22.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54085",
    "data-name": "Path 54085",
    d: "M276.089,182.177h-12.3a.689.689,0,0,1,0-1.377h12.3A.689.689,0,0,1,276.089,182.177Z",
    transform: "translate(-263.112 -180.8)",
    fill: "#44569b"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46516",
    "data-name": "Group 46516",
    transform: "translate(26.62 27.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54086",
    "data-name": "Path 54086",
    d: "M276.089,215.677h-12.3a.689.689,0,0,1,0-1.377h12.3A.689.689,0,0,1,276.089,215.677Z",
    transform: "translate(-263.112 -214.3)",
    fill: "#44569b"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46517",
    "data-name": "Group 46517",
    transform: "translate(26.62 31.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54087",
    "data-name": "Path 54087",
    d: "M276.089,249.277h-12.3a.689.689,0,0,1,0-1.377h12.3A.689.689,0,0,1,276.089,249.277Z",
    transform: "translate(-263.112 -247.9)",
    fill: "#44569b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreMedical);
export default __webpack_public_path__ + "static/media/explore-medical.40f87ad8651a79c13f5c28b127c7ad7b.svg";
export { ForwardRef as ReactComponent };